import React, { useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Divider, Grid, Header, Segment } from "semantic-ui-react";
import { closeModal } from "../../../app/common/modals/modalSlice";
import { convertFullName } from "../../../app/common/util/util";
import ModalWrapper from "../../../app/common/modals/modalWrapper";

export default function AgentSaveConfirmModal({
  existingPerson,
  newAgentData,
  onSaveChanges,
  onSaveAsNew,
  onDoNotSave
}) {
  const dispatch = useDispatch();
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  async function handleSaveChanges() {
    try {
      await onSaveChanges(); // This will close both modals
    } catch (error) {
      console.error("Error saving changes:", error);
      // Close only this modal on error
      if (isMountedRef.current) {
        dispatch(closeModal());
      }
    }
  }

  async function handleSaveAsNew() {
    try {
      await onSaveAsNew(); // This will close both modals
    } catch (error) {
      console.error("Error saving as new:", error);
      // Close only this modal on error
      if (isMountedRef.current) {
        dispatch(closeModal());
      }
    }
  }

  function handleDoNotSave() {
    onDoNotSave(); // This will close both modals
  }
  

  return (
    <ModalWrapper size="medium">
      <Segment clearing>
        <div className="medium horizontal margin small top margin">
          <Header size="large" color="blue">
            License Number Match Found
          </Header>
          <Divider />

          <p>
            The license number{" "}
            <strong>{newAgentData.brokerLicenseNumber}</strong> matches an
            existing contact in your People database but the email address is
            different.
            <br />
            You can choose to update the existing contact or save as a new
            contact.
          </p>

          <Divider />

          <Header size="small" color="blue">
            Existing Contact Information:
          </Header>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <strong>Name:</strong> {convertFullName(existingPerson)}
              </Grid.Column>
              <Grid.Column width={8}>
                <strong>Email:</strong> {existingPerson.email || "Not provided"}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4}>
                <strong>Phone:</strong> {existingPerson.phone || "Not provided"}
              </Grid.Column>
              <Grid.Column width={4}>
                <strong>License #:</strong>{" "}
                {existingPerson.brokerLicenseNumber || "Not provided"}
              </Grid.Column>
              <Grid.Column width={5}>
                <strong>Brokerage:</strong> {existingPerson.brokerageName}
              </Grid.Column>
            </Grid.Row>
            {existingPerson.hasAssistant && existingPerson.email && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <strong>Assistant:</strong>{" "}
                  {convertFullName(existingPerson.assistant)} [
                  {existingPerson.assistant.email}]{" "}
                  {existingPerson.assistant.phone && (
                    <span>{existingPerson.assistant.phone}</span>
                  )}
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>

          <Divider />

          <Header size="small" color="blue">
            New Agent Information:
          </Header>
          <Grid>
            <Grid.Row>
              <Grid.Column width={8}>
                <strong>Name:</strong> {convertFullName(newAgentData)}
              </Grid.Column>
              <Grid.Column width={8}>
                <strong>Email:</strong> {newAgentData.email || "Not provided"}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={8}>
                <strong>Phone:</strong> {newAgentData.phone || "Not provided"}
              </Grid.Column>
              <Grid.Column width={8}>
                <strong>License #:</strong>{" "}
                {newAgentData.brokerLicenseNumber || "Not provided"}
              </Grid.Column>
            </Grid.Row>
            {newAgentData.brokerageName && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <strong>Brokerage:</strong> {newAgentData.brokerageName}
                </Grid.Column>
              </Grid.Row>
            )}
          </Grid>

          <Divider />

          <p>What would you like to do?</p>

          <div className="ui three buttons">
            <Button color="grey" onClick={handleDoNotSave}>
              Do Not Save
            </Button>
            <Button color="green" onClick={handleSaveChanges}>
              Update Existing Contact
            </Button>
            <Button color="blue" onClick={handleSaveAsNew}>
              Save as New Contact
            </Button>
          </div>
        </div>
      </Segment>
    </ModalWrapper>
  );
}
